<div *ngIf="stepData && rect" class="tour-overlay">

  <!-- Glowing Highlight -->
  <div
    class="tour-highlight"
    [ngStyle]="getHighlightStyle()"
  ></div>

  <!-- Tooltip -->
  <div
    class="tour-tooltip"
    [class.auto-width]="stepData?.elementId !== 'brandingClariChat'"
    [ngStyle]="{
      top: rect.bottom + 20 + 'px',
      left: rect.left + 'px'
    }"
  >
    <h3 [innerHTML]="stepData.title" [class.first-step]="stepData?.elementId === 'brandingClariChat'"></h3>
    <p class="tour-description" [class.first-step]="stepData?.elementId === 'brandingClariChat'"
  [innerHTML]="stepData.description"
  ></p>

    <!-- NEW: Blocked message -->
    <p *ngIf="blockedMessage" class="blocked-message">
      ⚠ Please close the dropdown to continue the tour.
    </p>

    <div class="tour-controls">
      <button class="tour-prev"  [class.disabled]="blockedMessage" (click)="prev()">Back</button>

      <!-- Hide Next button if this step has openMenu or is blocked -->
      <button
        class="tour-next"
        [class.disabled]="blockedMessage"
        *ngIf="!stepData?.openMenu"
        [disabled]="blockedMessage"
        (click)="next()"
      >
        Next
      </button>

      <button class="tour-skip" (click)="skip()">End</button>

      <!-- Show Open button for special step -->
      <button
        *ngIf="stepData?.openMenu"
        (click)="openMenuAndContinue()"
        class="open-menu-btn"
      >
        Open
      </button>
    </div>
  </div>
</div>
